import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInAnonymously } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyB9iPNvY2RH-zAK8lw3EBMsgB2DAFLH7F4",
  authDomain: "mondanmic-ecommers.firebaseapp.com",
  databaseURL: "https://mondanmic-ecommers-default-rtdb.firebaseio.com",
  projectId: "mondanmic-ecommers",
  storageBucket: "mondanmic-ecommers.firebasestorage.app",
  messagingSenderId: "492813761135",
  appId: "1:492813761135:web:f85a6217eee8da6adaeb9a",
  measurementId: "G-GHTEQGNF9W"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const database = getDatabase(app);

export const initFirebaseAuth = async () => {
  try {
    if (!auth.currentUser) {
      await signInAnonymously(auth);
      console.log('Firebase anonymous auth signed in');
    }
  } catch (error) {
    console.error('Firebase anonymous sign-in failed:', error);
  }
};

export default app;
